import * as CubeTree from '../../cubeTree/index';
import Update from '../../update';

function sortById(sortTasks: LayerSortTask[]): void {
    let updateList: CubeId[] = [];

    sortTasks.forEach((task: LayerSortTask): void => {
        let sortLayer: CubeId = task.layerId;
        let layerCube: CubeNode = CubeTree.findByCubeId(sortLayer);
        let sortOrder: CubeId[] = task.cubeOrder;
        let childrenValue: CubeNode[] = CubeTree.findCubeChildKey(task.layerId);

        updateList.push(sortLayer);
        for (let i = sortOrder.length - 1; i >= 0; i--) {
            let cube: CubeNode = CubeTree.findByCubeId(sortOrder[i]);

            childrenValue.pop();
            childrenValue.unshift(cube);
            layerCube.jView.find(`.${layerCube.dslot}`).prepend(cube.jView);
        }
    });
    Update.updateCubeList(updateList);
    Update.updateEnd();
}

export {
    sortById
};
